import { createContext as s, useContext as c } from "react";
import { MimeTypeValidator as p } from "../Utils/index.js";
const n = s(
  null
), i = {
  selectedItems: [],
  // 已選擇的影片
  setSelectedItems: (e) => {
  },
  // 已選擇的影片 setter
  limit: 1,
  // 能選擇的影片數量
  uploadProps: {}
  // 上傳影片的屬性
}, l = () => {
  var t;
  const e = c(n), o = ((t = e == null ? void 0 : e.uploadProps) == null ? void 0 : t.accept) || void 0, r = new p(o);
  return {
    ...i,
    ...e,
    mime: r
  };
};
export {
  n as MediaLibraryContext,
  l as useProps
};
